module.exports = __webpack_public_path__ + "media/how_fastweb_works/02_unlock-1d489e81.jpg";